// main tools
import { useRef } from 'react'

// Components
import { IconComponent, IconName } from '@centria-ui-atoms/icon-component'
import { OverlayPanel } from '@centria-ui-atoms/overlay-panel'
import { Input, RadioButton } from '@centria-ui-atoms/input'
import { Typography } from '@centria-ui-atoms/typography'
import { Button } from '@centria-ui-atoms/button'

// Styles
import classes from './styles.module.scss'

// Types
import type { OverlayPanel as PrOverlayPanel } from 'primereact/overlaypanel'
import type { InputProps } from '@centria-ui-atoms/input'
import type { SetStateType } from '@centria-ui/types'
import type { ColumnProps } from 'primereact/column'
import type { FC } from 'react'

// i18n
import { useTranslation } from 'react-i18next'

export interface InputSearchProps extends InputProps {
  schema?: ColumnProps[]
  InputType?: JSX.Element
  icon?: IconName | 'none'
  globalFilter?: ColumnProps
  initialFilter?: () => void
  handleInput?: (value: string) => void
  setGlobalFilter?: SetStateType<ColumnProps>
}

export const InputSearch: FC<InputSearchProps> = ({
  schema,
  InputType,
  handleInput,
  globalFilter,
  initialFilter,
  className = '',
  setGlobalFilter,
  icon = 'SearchIcon',
  ...props
}) => {
  const { t } = useTranslation()
  const menuFilter = useRef<PrOverlayPanel>(null)

  const handleFilter = (item: ColumnProps) => {
    setGlobalFilter && setGlobalFilter(item)
    handleInput && handleInput('')
  }

  return (
    <div
      className={`p-input-icon-left p-input-icon-right ${classes.searchContainer}`}>
      {icon !== 'none' && <IconComponent icon={icon} />}
      {InputType || (
        <Input
          showIcon
          placeholder={`${t('search.searchBy')} ${globalFilter?.header ?? ''}`}
          {...props}
        />
      )}
      {!schema && initialFilter && (
        <IconComponent icon='ClearIcon' onClick={initialFilter} />
      )}

      {schema && (
        <>
          <IconComponent
            icon='FilterIcon'
            onClick={(ev) => menuFilter.current?.toggle(ev)}
          />
          {globalFilter && setGlobalFilter && (
            <OverlayPanel appendTo={document.body} panelRef={menuFilter}>
              <Typography
                fontcolor='primary'
                fontSize='subtitle'
                className='my-3 text-center'>
                {t('search.allFilters')}
              </Typography>
              <div className={classes.listFilter}>
                {schema?.map((item) => (
                  <RadioButton
                    value={item.field}
                    inputId={item.field}
                    name='globalfilteroption'
                    key={item.header as string}
                    label={item.header as string}
                    onChange={() => handleFilter(item)}
                    checked={globalFilter.field === item.field}
                  />
                ))}
              </div>
              {initialFilter && (
                <Button
                  className='mt-3'
                  variant='transparent'
                  onClick={initialFilter}>
                  <IconComponent size='lg' icon='ClearIcon' color='gray' />
                  <Typography fontcolor='light'>{t('search.clear')}</Typography>
                </Button>
              )}
            </OverlayPanel>
          )}
        </>
      )}
    </div>
  )
}
